/* Blog reader: scroll progress, TOC, recommended carousel, inline CTA */
(function () {
  const reader = document.querySelector(".melo-blog-reader");
  if (!reader) return;

  const progressRoot = reader.querySelector("[data-melo-blog-scroll-progress]");
  const progressFill = progressRoot
    ? progressRoot.querySelector(".melo-blog-scroll-progress-fill")
    : null;

  function initScrollProgress() {
    if (!progressFill) return;

    function updateProgress() {
      const doc = document.documentElement;
      const scrollTop = window.scrollY || doc.scrollTop;
      const scrollHeight = doc.scrollHeight - window.innerHeight;
      const ratio = scrollHeight > 0 ? Math.min(1, Math.max(0, scrollTop / scrollHeight)) : 0;
      progressFill.style.width = ratio * 100 + "%";
    }

    window.addEventListener("scroll", updateProgress, { passive: true });
    window.addEventListener("resize", updateProgress);
    updateProgress();
  }

  function initSidebarCurrent() {
    const sidebarPosts = reader.querySelector(".melo-blog-reader-sidebar--posts");
    if (!sidebarPosts) return;

    const currentSlug = sidebarPosts.getAttribute("data-current-slug");
    if (!currentSlug) return;

    sidebarPosts.querySelectorAll(".melo-blog-post-preview").forEach(function (link) {
      try {
        const path = new URL(link.href, window.location.origin).pathname.replace(/\/+$/, "");
        const slug = path.split("/").filter(Boolean).pop();
        if (slug === currentSlug) {
          const item = link.closest(".melo-blog-sidebar-list-item");
          if (item) {
            item.classList.add("is-current");
            link.setAttribute("aria-current", "page");
          }
        }
      } catch (e) {
        /* ignore malformed URLs */
      }
    });
  }

  function initRecommended() {
    const recommendedSections = reader.querySelectorAll("[data-melo-blog-recommended]");
    if (!recommendedSections.length) return;

    recommendedSections.forEach(function (recommended) {
      const track = recommended.querySelector("[data-melo-recommended-track]");
      const slides = Array.from(recommended.querySelectorAll("[data-melo-recommended-slide]"));
      const prevBtn = recommended.querySelector("[data-melo-recommended-prev]");
      const nextBtn = recommended.querySelector("[data-melo-recommended-next]");
      let index = 0;

      function showSlide(nextIndex) {
        if (!slides.length) return;
        index = (nextIndex + slides.length) % slides.length;
        if (track) {
          track.style.transform = "translate3d(-" + index * 100 + "%, 0, 0)";
        }
        slides.forEach(function (slide, i) {
          slide.setAttribute("aria-hidden", i === index ? "false" : "true");
        });
        if (prevBtn) prevBtn.disabled = slides.length <= 1;
        if (nextBtn) nextBtn.disabled = slides.length <= 1;
      }

      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          showSlide(index - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          showSlide(index + 1);
        });
      }

      showSlide(index);
      requestAnimationFrame(function () {
        recommended.classList.add("is-carousel-ready");
      });
    });
  }

  function normalizeLeadText(text) {
    return (text || "").replace(/\s+/g, " ").trim();
  }

  function initPostHeroLead() {
    const heroLead = reader.querySelector("[data-melo-post-hero-lead]");
    const contentSection = reader.querySelector(".melo-post-content");
    if (!heroLead || !contentSection) return;

    const introParagraph = Array.from(contentSection.children).find(function (el) {
      return el.tagName === "P";
    });
    if (!introParagraph) {
      if (!normalizeLeadText(heroLead.textContent)) {
        heroLead.remove();
      }
      return;
    }

    const introText = normalizeLeadText(introParagraph.textContent);
    const heroText = normalizeLeadText(heroLead.textContent);

    if (!heroText) {
      heroLead.textContent = introText;
      heroLead.hidden = false;
      introParagraph.remove();
      return;
    }

    heroLead.hidden = false;
    if (
      introText === heroText ||
      introText.indexOf(heroText) === 0 ||
      heroText.indexOf(introText) === 0
    ) {
      introParagraph.remove();
    }
  }

  initScrollProgress();
  initSidebarCurrent();
  initRecommended();
  initPostHeroLead();

  const content = reader.querySelector(".melo-post-content");
  const tocNav = reader.querySelector("[data-melo-blog-toc-list]");
  const tocAside = reader.querySelector("[data-melo-blog-toc-aside]");

  if (!content || !tocNav) return;

  function isTocHeading(heading) {
    if (heading.closest(".melo-blog-install-cta")) return false;
    return true;
  }

  const heroTitleEl = reader.querySelector(".melo-post-hero-title");
  const heroTitleText = heroTitleEl ? normalizeLeadText(heroTitleEl.textContent) : "";

  const headings = Array.from(content.querySelectorAll("h2, h3")).filter(function (heading) {
    if (!isTocHeading(heading)) return false;
    if (heading.tagName === "H2" && heroTitleText) {
      if (normalizeLeadText(heading.textContent) === heroTitleText) return false;
    }
    return true;
  });

  if (!headings.length) {
    if (tocAside) tocAside.hidden = true;
    return;
  }

  const slugify = function (text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  const tocLinks = [];
  let tocPinnedId = null;
  let tocPinTimer = null;

  function pinTocActive(id, durationMs) {
    tocPinnedId = id;
    clearTimeout(tocPinTimer);
    tocPinTimer = setTimeout(function () {
      tocPinnedId = null;
      resolveActiveHeading();
    }, durationMs);
  }

  function scrollToHeading(target) {
    const offset = getScrollOffset();
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
  }

  headings.forEach(function (heading, idx) {
    if (!heading.id) {
      const base = slugify(heading.textContent || "") || "section-" + (idx + 1);
      let id = base;
      let suffix = 2;
      while (document.getElementById(id)) {
        id = base + "-" + suffix;
        suffix += 1;
      }
      heading.id = id;
    }

    const link = document.createElement("a");
    link.className = "melo-blog-toc-link";
    link.href = "#" + heading.id;
    link.setAttribute("data-target", heading.id);
    link.innerHTML =
      '<span class="melo-blog-toc-link-text">' + heading.textContent.trim() + "</span>";
    link.addEventListener("click", function (event) {
      event.preventDefault();
      const target = document.getElementById(heading.id);
      if (!target) return;
      setActiveTocLink(heading.id);
      pinTocActive(heading.id, 1100);
      scrollToHeading(target);
      history.replaceState(null, "", "#" + heading.id);
    });
    tocNav.appendChild(link);
    tocLinks.push(link);
  });

  function getScrollOffset() {
    const nav = document.querySelector(".gh-navigation.melo-nav");
    const navHeight = nav ? nav.getBoundingClientRect().height : 64;
    return navHeight + 28;
  }

  function setActiveTocLink(activeId) {
    tocLinks.forEach(function (link) {
      const isActive = link.getAttribute("data-target") === activeId;
      link.classList.toggle("is-active", isActive);
      if (isActive) {
        link.setAttribute("aria-current", "location");
      } else {
        link.removeAttribute("aria-current");
      }
    });
  }

  function resolveActiveHeading() {
    if (tocPinnedId) {
      setActiveTocLink(tocPinnedId);
      return;
    }

    const offset = getScrollOffset();
    const activationLine = offset + 72;
    let activeId = headings[0].id;

    if (window.scrollY >= document.documentElement.scrollHeight - window.innerHeight - 4) {
      activeId = headings[headings.length - 1].id;
    } else {
      for (let i = headings.length - 1; i >= 0; i -= 1) {
        if (headings[i].getBoundingClientRect().top <= activationLine) {
          activeId = headings[i].id;
          break;
        }
      }
    }

    setActiveTocLink(activeId);
  }

  let scrollTicking = false;
  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function () {
      resolveActiveHeading();
      scrollTicking = false;
    });
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
  resolveActiveHeading();

  if (window.location.hash) {
    const hashId = window.location.hash.replace(/^#/, "");
    if (
      headings.some(function (h) {
        return h.id === hashId;
      })
    ) {
      requestAnimationFrame(function () {
        setActiveTocLink(hashId);
      });
    }
  }
})();
